import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { authGet } from '../../../utils/request';

const MetricWidget = (props) => {
  const {
    title, description, endpoint, path, color
  } = props;
  const [total, setTotal] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    setError(false);
    authGet(endpoint, { params: { size: 1 } })
      .then(({ data }) => {
        if (active) setTotal(data.total ?? 0);
      })
      .catch(() => {
        if (active) setError(true);
      });
    return () => { active = false; };
  }, [endpoint]);

  return (
    <Link
      to={path}
      className="block w-full h-full rounded-[8px] bg-white dark:bg-[#1b263b]
        border border-transparent dark:border-[#415a77]/60 shadow-card p-[20px]
        no-underline hover:no-underline"
    >
      <div className="text-[14px] text-text-muted mb-[12px]">{title}</div>
      <div className={`text-[36px] leading-none font-semibold ${color}`}>
        {error ? '—' : total ?? '…'}
      </div>
      <div className="text-[12px] text-text-muted mt-[10px]">
        {error ? 'Could not load data' : description}
      </div>
    </Link>
  );
};

MetricWidget.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  endpoint: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  color: PropTypes.string
};

MetricWidget.defaultProps = {
  color: 'text-primary'
};

export default MetricWidget;
